import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { Card, CardBody, Modal, ModalBody, Button } from "reactstrap";
import { Transfer } from "antd";
import CheckboxMI from "@mui/material/Checkbox";
import { connect } from "react-redux";
import Axios from "axios";
import Swal from "sweetalert2";
import Fade from "react-reveal/Fade";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";

import Loader from "../../Global/Loader";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { openNotification } from "../Components/Notification";

import { Services } from "../../../repositories/clients/Services";
import Table from "./../Components/Table";

class Alerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchOnInit: false,
      actionType: 1,
      transferLabels: [this.props.t("add"), this.props.t("eliminate")],
      checkedList: [],
      entityCatalog: [],
      data: [],
      searchText: "",
      modalIsOpen: false,
      loadingInfo: true,
      agregarDesasignar: (
        <div className="float-right">
          <Button
            color="primary"
            className="d-flex align-items-center"
            onClick={this.showModalAsignar}
          >
            {this.props.t("assign_deallocate")}
          </Button>
        </div>
      ),
      columns: [
        {
          customHeader: () => (
            <CheckboxMI
              style={{ paddingBottom: "0", color: "#fdfbfb", marginBottom: '8px' }}
              onChange={this.toggleAll}
              color="primary"
            />
          ),
          label: "",
          key: "",
          minWidth: 60,
          maxWidth: 60,
          custom: (value) => (
            <CheckboxMI
              style={{ color: "#000a2e" }}
              onChange={this.handleChange(value.AlertNotificationId)}
              checked={value.AlertChecked}
              color="primary"
            />
          ),
        },

        {
          label: "ID",
          key: "AlertNotificationId",
          minWidth: 60,
          maxWidth: 60,
          custom: (value) => (
            <span
              className="link-euro"
              onClick={() => {
                this.editRow(value);
              }}
            >
              {value.AlertNotificationId}
            </span>
          ),
        },
        { label: this.props.t("name"), key: "Name", minWidth: 130 },
        {
          label: this.props.t("description"),
          key: "Description",
          minWidth: 130,
        },
        { label: this.props.t("type"), key: "Type", minWidth: 130 },
        {
          label: this.props.t("associated_clients"),
          key: "CountCustomer",
          minWidth: 130,
        },
      ],
    };
  }

  componentDidMount = () => {
    this.init();
  };

  init = () => {
    this.getAlertList();
    this.getEntityCatalog();
    this.setState({
      checkedList: [],
      modalIsOpen: false,
      selectedEntities: [],
      actionType: 1,
    });
  };
  showModalAsignar = () => {
    this.setState({ modalIsOpen: true });
  };

  toggleAll = (event) => {
    let { checkedList, data } = this.state;
    let checked = event.target.checked;
    checkedList = [];
    data.map((d) => {
      d.AlertChecked = checked;
      if (checked) {
        checkedList.push(d.AlertNotificationId);
      }
    });
    this.setState({
      checkedList,
      data,
    });
  };
  handleChange = (id) => (event) => {
    let { checkedList, data } = this.state;
    let checked = event.target.checked;
    if (checked) {
      checkedList.push(id);
    } else {
      let index = checkedList.findIndex((v) => {
        return v == id;
      });
      checkedList.splice(index, 1);
    }
    data.map((d) => {
      if (d.AlertNotificationId == id) {
        d.AlertChecked = checked;
      }
    });

    this.setState({
      checkedList,
      data,
    });
  };
  // sendMessage = (text, type) => {
  //     Swal.fire({
  //         icon: type,
  //         confirmButtonColor: "#000a2e",
  //         confirmButtonText: "Ok",
  //         html: `<div class="text-center">
  //   ${text}
  //   </div>`,
  //     });
  // }

  sendMessage = (text, type) => {
    Swal.fire({
      // icon: type,
      confirmButtonColor: "#0561fc",
      confirmButtonText: "Ok",
      customClass: "small-swal",
      html: `<div class="text-center euro-title-form" style="margin-top: 35px">
      ${text}
      </div>`,
      customClass: {
        confirmButton: 'custom-width-btn swal'
      }
    });
  };

  getAlertList = async () => {
    const { lng, _user } = this.props;

    try {
      const response = await Axios.post(`${Services.ADMIN.path}alerts/all`, {
        lng,
        userId: _user
      });

      this.setState({
        data: response.data.data,
        loadingInfo: false
      });
    } catch (error) {
      console.error("Error fetching alerts:", error);
      this.setState({ loadingInfo: false });
    }
  };

  getEntityCatalog = async () => {
    let { entityCatalog } = this.state;
    try {
      let resp = await Axios.get(`${Services.ADMIN.path}admin/entities`);
      entityCatalog = this.sortCatalogs(resp.data.clientes, "text");
      this.setState({ entityCatalog });
    } catch (ex) {
      console.error(ex);
    }
  };

  //### Agregar o desasignar #########

  sortCatalogs = (array, attr) => {
    array.sort((a, b) => a[attr].localeCompare(b[attr]));
    return array;
  };
  filterOption = (a, b, c) => {
    return b.label.toLowerCase().indexOf(a.toLowerCase()) > -1;
  };

  cancelarModal = () => {
    this.setState({ modalIsOpen: false, selectedEntities: [] });
  };

  guardarAsignarDesasignar = async () => {
    let { checkedList, selectedEntities, actionType } = this.state;
    let data = {
      Alerts: checkedList,
      Entities: selectedEntities,
      Type: actionType,
    };
    try {
      this.setState({ loadingInfo: true }, async () => {
        await Axios.put(`${Services.ADMIN.path}alerts/multConfAlert`, data);
        openNotification('success', this.props.t("alerts_update_succesful"),);
        this.init();
      });
    } catch (ex) {
      console.error(ex);
    }
  };

  onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index && value != null && value != "";
  };

  handleChangeFilter = (nextTargetKeys, direction, moveKeys) => {
    let { selectedEntities, actionType } = this.state;
    if (selectedEntities) {
      if (direction === "left") {
        moveKeys.forEach((key) => {
          var removeKey = selectedEntities.indexOf(key);
          if (removeKey > -1) {
            selectedEntities.splice(removeKey, 1);
          }
        });

        // this.sendMessage("Retirado", "info");
      } else {
        moveKeys.forEach((key) => {
          selectedEntities.push(key);
        });

        // this.sendMessage(actionType == 1 ? "Agregado" : "Desasignado", "info");
      }

      selectedEntities = selectedEntities.filter(this.onlyUnique);
    } else {
      this.sendMessage(
        actionType == 1 ? this.props.t("added") : this.props.t("deallocated"),
        "info"
      );
      selectedEntities = moveKeys;
    }

    this.setState({ selectedEntities });
  };
  changeAsignarDes = (event) => {
    console.log(event.target.value);
    this.setState({
      actionType: parseInt(event.target.value),
      transferLabels:
        parseInt(event.target.value) == 1
          ? [this.props.t("add"), this.props.t("eliminate")]
          : [this.props.t("add"), this.props.t("eliminate")],
      selectedEntities: [],
    });
  };
  //###################################

  editRow = (value) => {
    this.props.history.push(`/info-alert/${value.AlertNotificationId}`);
  };
  handleCancel = (value) => {
    let { data } = this.state;
    data.map((d) => {
      if (value.UserId === d.UserId) {
        d.showPop = false;
      }
    });
    this.setState({
      data,
    });
  };

  /*=============================================
    =            Render Method                    =
    =============================================*/

  render() {
    let { columns, data, searchOnInit, searchText, loadingInfo } = this.state;
    return loadingInfo ? (
      <Loader />
    ) : (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-alerts-notifications icon-header" />
          {this.props.t("alert_notifications")}
        </div>
        <Card className="myCard">
          <CardBody>
            <Table
              columns={columns}
              data={data}
              itemsByPage={10}
              name="UserList"
              modalName="ui Modal body order list"
              customer={this.props._customer}
              customAdd={
                this.state.checkedList.length > 1
                  ? this.state.agregarDesasignar
                  : false
              }
              user={this.props._user}
              // info={
              //   {

              //     // config: columnsConfig
              //     config: {
              //       title: fechaDescarga,
              //       titlePosition: {
              //         col: 11,
              //         row: 5

              //       }

              //     }
              //   }
              // }
              rowClick={false}
              customClick={this.editRow}
              options={{
                pagination: true,
                search: true,
                panel: false,
                downloads: {
                  xlsx: false,
                  pdf: false,
                },
                selectItems: false,
                orderAttention: {
                  activeFilter: searchOnInit,
                  activeText: searchText,
                  search: true,
                  xlsx: false,
                },
                trigger: this.selectedOrder,
                searchKeys: ["Name", "Description", "Type"],
              }}
              cellType={"thick-rows"}
            />
          </CardBody>
        </Card>
        <Modal
          isOpen={this.state.modalIsOpen}
          size="lg"
          style={{ width: "100%" }}
          toggle={this.toggle}
        >
          <ModalBody style={{ padding: "0 30px 15px" }}>
            <div className="row">
              <div style={{ marginTop: "15px" }} key={"tipoproceso"}>
                <Fade left opposite>
                  {" "}
                  <span>
                    <label className="titleCardResumen">Acción</label>
                  </span>
                </Fade>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "3px",
                  }}
                >
                  <RadioGroup
                    row
                    defaultValue={"1"}
                    onChange={this.changeAsignarDes}
                  >
                    <FormControlLabel
                      sx={{
                        "& .MuiTypography-root": {
                          fontSize: 12,
                          color: "#000a2e",
                          fontFamily: "SF Pro Display !important"
                        },
                      }}
                      value="1"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 12,
                              color: "#000a2e",
                              fontFamily: "SF Pro Display !important"
                            },
                          }}
                        />
                      }
                      label={this.props.t("assign")}
                    />
                    <FormControlLabel
                      sx={{
                        "& .MuiTypography-root": {
                          fontSize: 12,
                          color: "#000a2e",
                          fontFamily: "SF Pro Display !important"

                        },
                      }}
                      value="0"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 12,
                              color: "#000a2e",
                              fontFamily: "SF Pro Display !important"
                            },
                          }}
                        />
                      }
                      label={this.props.t("deallocate")}
                    />
                  </RadioGroup>
                </div>
              </div>
            </div>
            <div className="row" style={{ paddingLeft: "5%" }}>
              <Transfer
                listStyle={{
                  maxWidth: "45%",
                  width: "45%",
                }}
                style={{
                  marginTop: "25px",
                  width: "90%",
                  height: "350px",
                  fontSize: "12px",
                }}
                locale={{
                  itemUnit: this.props.t("company"),
                  itemsUnit: this.props.t("companies"),
                  searchPlaceholder: "",
                }}
                dataSource={this.state.entityCatalog}
                showSearch
                filterOption={this.filterOption}
                onChange={this.handleChangeFilter}
                render={(item) => item.label}
                operations={this.state.transferLabels}
                targetKeys={this.state.selectedEntities}
              // showSelectAll={false}
              />
            </div>
            <div className="row" style={{ marginTop: "15px" }}>
              <div className="col-6">
                <Button
                  color="secondary"
                  className="float-right custom-width-btn"
                  onClick={() => {
                    this.cancelarModal();
                  }}
                >
                  {this.props.t("cancel")}
                </Button>
              </div>
              <div className="col-6">
                <Button
                  color="primary"
                  className="float-left custom-width-btn"
                  onClick={() => this.guardarAsignarDesasignar()}
                >
                  {this.props.t("save")}
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(Alerts)));
